import createAction from '../actions';

export const SHOW_PROFILE_BOX = createAction('SHOW_PROFILE_BOX');

export const showProfileBox = () => ({ type: SHOW_PROFILE_BOX });
